import styled from "styled-components";
import {JackpotBetWidgetHighlightedTextDefaultBox} from "./jackpot-bet-widget-highlighted-text.default.box";
import {baseColors} from "../../../../themes/definitions/casino777/base-colors";

export const JackpotBetWidgetHighlightedText777Box = styled(JackpotBetWidgetHighlightedTextDefaultBox)`
  background: ${baseColors.base05Contrast};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;
